export default "__VITE_PUBLIC_ASSET__3631f96d__"